const modul = {
	namespaced: true,

	state: {
		rullningsbaraElement: [ 	// = initiala defaultvärden
			{ id:'re1', scrollTop: 0 },
		],
	},

	mutations: {

		// rullningsbaraElement muteras via en "root mutation" som används av flera modules/namespaces:
	},

	//actions: { ... },

	//getters: { ... }
};

export { modul as ssoStatestoreOversikt }
